(function() {
    'use strict';

    angular
        .module('MW.ContactManager.CustomToastService', [
        ])
        .service('mwCustomToastService', [
            function() {
                this.simpleTimedClosable = function simpleTimedClosable(textContent) {
                    return {
                        template: `
                            <md-toast class="custom-simple-timed-closable-toast">
                                <div class="md-toast-content">
                                    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">
                                        {{ $ctrl.saveToastMessage }}
                                    </span>
                                    <mw-icon-button ng-click="$ctrl.$mdToast.hide()" svg-icon="navigation:ic_close_24px" hover="false" aria-label="close"></mw-icon-button>
                                </div>
                            </md-toast>
                        `,
                        hideDelay: 4000,
                        bindToController: true,
                        controllerAs: '$ctrl',
                        controller: class ToastController {
                            constructor($mdToast) {
                                'ngInject';

                                this.$mdToast = $mdToast;
                                this.saveToastMessage = textContent;
                            }
                        }
                    };
                };
            }
        ]);
}());